import CommonState, { CmNotification, ErrorStatus } from './state'

function notifications(state: CommonState): CmNotification[] {
  return state.notifications
}

function errorStatus(state: CommonState): ErrorStatus {
  return state.errorStatus
}

export default {
  notifications,
  errorStatus
}
